const enumType = [
	{ label: '否', value: '0' },
	{ label: '是', value: '1' },
];

export const productInfoList = [
	{ label: '产品名称/通用名称', value: '', prop: 'cpmctymc' },
	{ label: '规格型号', value: '', prop: 'ggxh' },
	{ label: '产品描述', value: '', prop: 'cpms' },
	{ label: '注册证编号或者备案凭证编号', value: '', prop: 'zczbhhzbapzbh' },
	{ label: '医疗器械注册人/备案人名称', value: '', prop: 'ylqxzcrbarmc' },
	{ label: '统一社会信息代码', value: '', prop: 'tyshxydm' },
	{ label: '主键编号', value: '', prop: 'devicerecordkey' },
	{ label: '最小销售单元产品标识', value: '', prop: 'zxxsdycpbs' },
	{ label: '是否为包类/组套类产品', value: '', prop: 'sfwblztlcp', enum: enumType },
	{ label: '版本号', value: '', prop: 'versionnumber' },
	{ label: '版本的发布时间', value: '', prop: 'versiontime' },
	{ label: '版本状态', value: '', prop: 'versionstatus' },
	{ label: '产品标识编码体系名称（IDcode）', value: '', prop: 'cpbsbmtxmc' },
	{ label: '产品标识发布日期', value: '', prop: 'cpbsfbrq' },
	{ label: '最小销售单元中使用单元的数量', value: '', prop: 'zxxsdyzsydydsl' },
	{ label: '使用单元产品标识', value: '', prop: 'sydycpbs' },
	{ label: '本体产品标识', value: '', prop: 'btcpbs' },
	{ label: '器械类别', value: '', prop: 'qxlb' },
	{ label: '产品类别', value: '', prop: 'cplb' },
	{ label: '原分类编码', value: '', prop: 'yflbm' },
	{ label: '是否标记为一次性使用', value: '', prop: 'sfbjwycxsy', enum: enumType },
	{ label: '最大重复使用次数', value: '', prop: 'zdcfsycs' },
	{ label: '是否为无菌包装', value: '', prop: 'sfwwjbz' },
	{ label: '使用前是否需要进行灭菌', value: '', prop: 'syqsfxyjxmj' },
	{ label: '灭菌方式', value: '', prop: 'mjfs' },
	{ label: '医保编码', value: '', prop: 'ybbm' },
	{ label: '生产标识是否包含批号', value: '', prop: 'scbssfbhph' },
	{ label: '生产标识是否包含序列号', value: '', prop: 'scbssfbhxlh' },
	{ label: '生产标识是否包含生产日期', value: '', prop: 'scbssfbhscrq' },
	{ label: '生产标识是否包含失效日期', value: '', prop: 'scbssfbhsxrq' },
	{ label: '储存或操作条件', value: '', prop: 'cchcztj' },
];
